function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from "react";
import PropTypes from "prop-types";
export var VictoryAccessibleGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(VictoryAccessibleGroup, _React$Component);

  var _super = _createSuper(VictoryAccessibleGroup);

  function VictoryAccessibleGroup() {
    _classCallCheck(this, VictoryAccessibleGroup);

    return _super.apply(this, arguments);
  }

  _createClass(VictoryAccessibleGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          desc = _this$props.desc,
          children = _this$props.children,
          className = _this$props.className,
          tabIndex = _this$props.tabIndex;
      var descId = desc && (this.props["aria-describedby"] || desc.split(" ").join("-"));
      return desc ? /*#__PURE__*/React.createElement("g", {
        "aria-label": this.props["aria-label"],
        "aria-describedby": descId,
        className: className,
        tabIndex: tabIndex
      }, /*#__PURE__*/React.createElement("desc", {
        id: descId
      }, desc), children) : /*#__PURE__*/React.createElement("g", {
        "aria-label": this.props["aria-label"],
        "aria-describedby": this.props["aria-describedby"],
        className: className,
        tabIndex: tabIndex
      }, children);
    }
  }]);

  return VictoryAccessibleGroup;
}(React.Component);
VictoryAccessibleGroup.displayName = "VictoryAccessibleGroup";
VictoryAccessibleGroup.propTypes = {
  "aria-describedby": PropTypes.string,
  "aria-label": PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  desc: PropTypes.string,
  tabIndex: PropTypes.number
};
VictoryAccessibleGroup.defaultProps = {
  className: "VictoryAccessibleGroup"
};